import { Box, Typography, Link, IconButton } from "@mui/material";
import { Facebook, Twitter, LinkedIn, Instagram } from "@mui/icons-material";

const LandingFooter = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "var(--secondary-blue)",
        color: "white",
        pt: "3rem",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" },
          gap: "2rem",
          px: { xs: "2rem", md: "6rem" },
          pb: "2rem",
        }}
      >
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              mb: "1rem",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            About Us
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8, lineHeight: 1.6 }}>
            We make shipping simple, fast, and affordable for Canadian
            businesses with real-time rates and dedicated support.
          </Typography>
        </Box>

        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              mb: "1rem",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            Quick Links
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            <Link
              href="https://skymartexpress.com"
              color="inherit"
              underline="hover"
              target="_blank"
            >
              Home
            </Link>
            <Link
              href="https://skymartexpress.com"
              color="inherit"
              underline="hover"
              target="_blank"
            >
              Shipping Rates
            </Link>
            <Link
              href="https://skymartexpress.com"
              color="inherit"
              underline="hover"
              target="_blank"
            >
              Features
            </Link>
            <Link
              href="https://skymartexpress.com"
              color="inherit"
              underline="hover"
              target="_blank"
            >
              Contact
            </Link>
          </Box>
        </Box>

        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              mb: "1rem",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            Get in Touch
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Email: info@skymart.ca
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Phone: +1 800-808-0215
          </Typography>
          <Box sx={{ mt: "1rem", display: "flex", gap: "0.5rem" }}>
            <IconButton
              component={Link}
              href="https://skymartexpress.com"
              color="inherit"
              size="small"
              target="_blank"
            >
              <Facebook />
            </IconButton>
            <IconButton
              component={Link}
              href="https://skymartexpress.com"
              color="inherit"
              size="small"
              target="_blank"
            >
              <Twitter />
            </IconButton>
            <IconButton
              component={Link}
              href="https://skymartexpress.com"
              color="inherit"
              size="small"
              target="_blank"
            >
              <LinkedIn />
            </IconButton>
            <IconButton
              component={Link}
              href="https://skymartexpress.com"
              color="inherit"
              size="small"
              target="_blank"
            >
              <Instagram />
            </IconButton>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          backgroundColor: "rgba(255,255,255,0.1)",
          textAlign: "center",
          py: "1rem",
          fontSize: "0.875rem",
        }}
      >
        © {new Date().getFullYear()} Skymart. All rights reserved.
      </Box>
    </Box>
  );
};

export default LandingFooter;
